import { z } from "zod";

export const WebsiteScrapeSchema = z.object({
	// The balance is a SUM over a DECIMAL column and arrives as a string — coerce at the boundary
	// so no consumer concatenates instead of adding (apps/web/CLAUDE.md §6).
	credits: z.coerce.number(),
});

export type WebsiteScrape = z.infer<typeof WebsiteScrapeSchema>;
